import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import { PostMediaEndlinkRequest } from "./interfaces/post-media-endlink";
import { PostMultipleMediaEndlinksResponse } from "./interfaces/post-multiple-media-endlinks";

export async function postMultipleMediaEndlinks(
  data: PostMediaEndlinkRequest,
  env: Environment
): Promise<PostMultipleMediaEndlinksResponse | ResponseError> {
  const url = `${getBaseUrl(env)}cxm/media/multiple-endlinks`;
  const header = await getHeader();

  try {
    const response =
      await fetchWrapper.postAsync<PostMultipleMediaEndlinksResponse>(
        url,
        data,
        header
      );

    if (response && !response.hasError && response.data) {
      return response.data;
    }

    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error
    };
    return error;
  } catch {
    return {
      isError: true,
      statusCode: 0,
      errorResult: { message: "Network error" }
    } as ResponseError;
  }
}
